import React from 'react';
import { LanguageSelector as ReactAutoGoogleTranslateLanguageSelector } from 'react-auto-google-translate';

const specificLanguages = [
  { value: 'vi', label: 'Tiếng Việt', countryCode: 'vn' },
  { value: 'en', label: 'English', countryCode: 'us' },
];

const LanguageSelector: React.FC = () => {
  return (
    <ReactAutoGoogleTranslateLanguageSelector
      onlySpecificLanguages={specificLanguages}
      className="language-selector"
    />
  );
};

export default LanguageSelector;
